import React, { useState } from "react";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { fetchAuthenticationLogin } from "../../../services/api-raindrop.js";
import { isLocalEnvironment } from "../../../services/environment.js";

const StageMagicLinkSent = ({ onBack, urlMagicLink }) => {
  return (
    <div className="flex flex-col gap-12 items-center">
      <i className="fas fa-paper-plane text-7xl text-color-dark-text-tertiary"></i>

      <div className="text-center text-color-dark-text-tertiary">
        Please click the link in the email we just sent you.
      </div>

      <RaindropButton
        title={"Back"}
        onClick={onBack}
        icon={"fa-arrow-left"}
        style={ButtonStyle.Secondary}
      />

      {isLocalEnvironment() && urlMagicLink && (
        <RaindropButton
          to={urlMagicLink}
          title="Click here (local only)"
          style={ButtonStyle.Primary}
          icon="fa-bomb"
        />
      )}
    </div>
  );
};

const CirrusLogin = () => {
  const [email, setEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSentMagicLink, setHasSentMagicLink] = useState(false);

  const [urlMagicLink, setUrlMagicLink] = useState();

  const onSubmit = () => {
    setHasSentMagicLink(true);
    setIsLoading(true);

    fetchAuthenticationLogin({
      email: email,
      application: "cirrus",
    })
      .then((data) => {
        setHasSentMagicLink(true);
        console.log(data, "RD-666");

        if (isLocalEnvironment()) {
          setUrlMagicLink(data?.url_magic_link);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onBack = () => {
    setEmail(null);
    setHasSentMagicLink(false);
  };

  if (hasSentMagicLink) {
    return <StageMagicLinkSent onBack={onBack} urlMagicLink={urlMagicLink} />;
  }

  return (
    <div className="flex flex-col w-full h-full max-w-lg items-center justify-center gap-12">
      <div className="flex flex-col text-left gap-6">
        <div className="text-4xl font-bold">Login</div>

        <div className="text-sm text-color-dark-text-secondary">
          Welcome back! Let's get you logged in. Enter your email below and
          we'll send you a magic link to get started.
        </div>
      </div>
      <RaindropInput
        label={"Email"}
        value={email}
        example={"walter.waters@example.com"}
        onChange={(e) => setEmail(e.target.value)}
        isFluid={true}
        icon={""}
      />
      <div className="flex flex-col gap-4 items-center">
        <RaindropButton
          title="Send Magic Link"
          onClick={onSubmit}
          style={ButtonStyle.Primary}
          isLoading={isLoading}
        />

        <RaindropButton
          title="Back"
          to={"/cirrus/entry"}
          style={ButtonStyle.Secondary}
        />
      </div>
    </div>
  );
};

export default CirrusLogin;
